import * as THREE from 'three'

export type FighterNormalizationReport={
 source:'skinned'|'mesh'|'none'
 candidates:number
 originalHeight:number
 appliedScale:number
 finalHeight:number
 suspicious:boolean
}

const finiteBox=(box:THREE.Box3)=>{
 const size=box.getSize(new THREE.Vector3())
 return !box.isEmpty()&&[box.min.x,box.min.y,box.min.z,box.max.x,box.max.y,box.max.z,size.x,size.y,size.z].every(Number.isFinite)&&size.y>1e-6
}

export function fighterReferenceBounds(root:THREE.Object3D){
 root.updateMatrixWorld(true)
 const skinned=new THREE.Box3(),fallback=new THREE.Box3()
 let skinnedCount=0,meshCount=0
 root.traverse(node=>{
  if(!(node instanceof THREE.Mesh)||node.userData.inyronMeshQuarantined)return
  const box=new THREE.Box3()
  try{box.setFromObject(node)}catch{return}
  if(!finiteBox(box))return
  fallback.union(box);meshCount++
  if(node instanceof THREE.SkinnedMesh){skinned.union(box);skinnedCount++}
 })
 if(skinnedCount&&finiteBox(skinned))return{box:skinned,source:'skinned' as const,candidates:skinnedCount}
 if(meshCount&&finiteBox(fallback))return{box:fallback,source:'mesh' as const,candidates:meshCount}
 return{box:new THREE.Box3(),source:'none' as const,candidates:0}
}

export function normalizeFighterGeometry(root:THREE.Object3D,targetHeight=1.8):FighterNormalizationReport{
 const reference=fighterReferenceBounds(root)
 if(reference.source==='none')return{source:'none',candidates:0,originalHeight:0,appliedScale:1,finalHeight:0,suspicious:true}
 const originalHeight=reference.box.getSize(new THREE.Vector3()).y
 const rawScale=originalHeight>1e-6?targetHeight/originalHeight:1
 const appliedScale=Number.isFinite(rawScale)?THREE.MathUtils.clamp(rawScale,1e-4,1e4):1
 root.scale.multiplyScalar(appliedScale)
 root.updateMatrixWorld(true)
 const fitted=fighterReferenceBounds(root)
 if(fitted.source!=='none'){
  const center=fitted.box.getCenter(new THREE.Vector3())
  root.position.x-=center.x
  root.position.y-=fitted.box.min.y
  root.position.z-=center.z
  root.updateMatrixWorld(true)
 }
 const finalRef=fighterReferenceBounds(root)
 const finalHeight=finalRef.source==='none'?0:finalRef.box.getSize(new THREE.Vector3()).y
 const suspicious=!Number.isFinite(finalHeight)||finalHeight<targetHeight*.82||finalHeight>targetHeight*1.18
 const report={source:reference.source,candidates:reference.candidates,originalHeight,appliedScale,finalHeight,suspicious}
 root.userData.inyronNormalization=report
 return report
}
